<div class="horizontal-bar-chart" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"
	[style]="{'--bar-color': barColor}">
	<ng-container *ngIf="barData">
		<ng-container *ngFor="let dataset of barData?.graph?.datasets;">
			<div class="horizontal-bar-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
				fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px">
				<ng-container *ngFor="let data of dataset?.data; let i = index;">
					<ng-container *ngIf="i === 0">
						<div class="bar-item-caption" fxFlex="0 0 30%" fxFlex.xs="auto" fxLayoutAlign="end center"
							fxLayoutAlign.xs="start center">
							<p class="bar-item-title">
								{{ data }}
							</p>
						</div>
					</ng-container>
					<ng-container *ngIf="i === 1">
						<div class="bar-item-progress" fxFlex="1 1" fxFlex.xs="auto" (click)="info(dataset)">
							<mat-progress-bar mode="determinate" [value]="data" class="horizontal-progress-bar">
							</mat-progress-bar>
						</div>
					</ng-container>
					<ng-container *ngIf="i === 2">
						<div class="body-text" (click)="info(dataset?.data)" fxFlex="0 0 25%">{{ data }}</div>
					</ng-container>
				</ng-container>
			</div>

		</ng-container>
	</ng-container>
</div>
